import React from 'react';
import './Main_add_account.css';
import { Link } from 'react-router-dom';

import Tracker from '../../../layout_components/Tracker/Tracker.js';
import Add_step_1 from '../Add_step_1/Add_step_1.js';
import Add_step_2 from '../Add_step_2/Add_step_2.js';
import Add_step_3 from '../Add_step_3/Add_step_3.js';
import MasterButton from '../../../general_components/MasterButton/MasterButton.js';

import GGApi from '../../../../utils/GGApi.js';

import dates from '../../../../utils/dates.js';
import Header_for_multistep from '../../../layout_components/Header_for_multistep/Header_for_multistep';
import money from '../../../../utils/money';

import config from '../../../../utils/config';

import amplitude from 'amplitude-js';
amplitude.getInstance().init(config.amp_key);

class Main_add_account extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            //form details
            currentStep: 1,
            buttonText: 'Next',
            buttonLinks: false,

            //submission details
            account_name: '',
            account_name_unique: '',
            birthday: '',
            target_savings: '',
            target_date: '',

            //supporting states for masking purposes
            birthday_support:'',
            target_date_support: '',

            //results
            new_account_id: ''
        }

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleTargetDateChange = this.handleTargetDateChange.bind(this);
        this.handleDollarInput = this.handleDollarInput.bind(this);
        this.checkUnique = this.checkUnique.bind(this);
    }

    // button clicks
    handleButtonClick() {
        let step = this.state.currentStep;        

        if (step === 1) {
            //validate that a name has been inputted
            if(!this.state.account_name){
                alert('Please submit a valid recipient name, up to 50 characters.')
            } else if (!this.state.account_name_unique) {
                alert('You already have a recipient with this name. Please Choose a different name for this recipient account.');
            } else {

                // validate the birthday date
                    // check for a full number of characters
                if (!(this.state.birthday.length === 10)) {
                    alert('Please input a valid birthday in the following format: \nMM/DD/YYYY');
                    //check that the input is a valid date between the years 1900-2200
                } else if (!dates.validateDate(this.state.birthday)) {
                    alert('Please input a valid birthday in the following format: \nMM/DD/YYYY');
                } else {
                    // amplitude
                    amplitude.getInstance().logEvent('new recipient: submit personal info')
                    //
                    step += 1;
                    this.setState({currentStep: step, buttonText: 'Add recipient'});
                }
            }
        } else if (step === 2) {
            // validate target savings
            let target_savings = Number(this.state.target_savings.slice(1).split(',').join(''));
            if (isNaN(target_savings )) {
                alert('Please input a valid target savings $ amount in whole dollars');

            } else if (target_savings < 1 ){
                alert('Please input a valid target savings $ amount in whole dollars');

            // validate the target date
            } else {
                // check for a full number of characters
                if (!(this.state.target_date.length === 10) || !dates.validateDate(this.state.target_date) || !dates.checkFutureDate(this.state.target_date)) {
                    alert('Please input a valid future target date in the following format: \nMM/DD/YYYY');
                } else {
                    // amplitude
                    amplitude.getInstance().logEvent('new recipient: submit goal')
                    //
                    step += 1;
                    // use the gg api here to send the new account's info to the database
                    let newAccount = {
                        account_name: this.state.account_name,
                        birthday: dates.sqlizeDate(this.state.birthday),
                        target_savings: Number(this.state.target_savings.slice(1).split(',').join('')),
                        target_date: dates.sqlizeDate(this.state.target_date)
                    };
                    
                    GGApi.add_account(newAccount).then(result => {
                        
                        // move to final flow screen
                        this.setState(
                            {
                                currentStep: step, 
                                buttonText: 'Finish',
                                new_account_id: result.new_account_id
                            });
                    });
                };
            }
            
        } else if (step === 3) {
            /* reset the state for the next flow 
            this.setState(
                {
                currentStep: 1,
                buttonText: 'Next'
                });
                */
            amplitude.getInstance().logEvent('new recipient: finish')
            // go back to the last screen before this flow
            const urlParams = new URLSearchParams(window.location.search);
            if(urlParams.get('source')){
                window.location.href = 'receive/'+urlParams.get('source');
            } else {
                window.location.href = 'plan'
            }
            //this.props.history.goBack();

        } 
    }


    handleBackButton() {
        let step = this.state.currentStep;
        const urlParams = new URLSearchParams(window.location.search);
        if (step === 1) {
            //this.props.history.goBack()
            // go back to the last screen before this flow
            if(urlParams.get('source')){
                window.location.href = 'receive/'+urlParams.get('source');
            } else {
                window.location.href = 'plan'
            }

        } else if (step === 2) {
            step -= 1;
            this.setState({currentStep: step});

        } else if (step === 3) {
            //this.props.history.goBack();
            // go back to the last screen before this flow
            if(urlParams.get('source')){
                window.location.href = 'receive/'+urlParams.get('source');
            } else {
                window.location.href = 'plan'
            }
        };
    }

    // input event handlers
    handleChange(event) {
        const { name, value} = event.target;
        this.setState({[name]: value});
    }

    checkUnique(event, type) {
        if (type === 'account_name') {
            GGApi.unique_child_account(event.target.value.toLowerCase()).then(unique => {
                if(!unique) {
                    alert('You already have a recipient with this name. Please Choose a different name for this recipient account.');
                };
                this.setState({account_name_unique: unique});
            });
        } 
    }

    handleDateChange(event) {
        const { name, value} = event.target;
        this.setState({[name]: value, birthday_support: value});

        if (event.target.value.length === 2 && this.state.birthday_support.length === 1) {
            let newValue = value + "/";
            this.setState({[name]: newValue});
        } else if (event.target.value.length === 5 && this.state.birthday_support.length === 4) {
            let newValue = value + "/";
            this.setState({[name]: newValue});
        };  
    }

    handleTargetDateChange(event) {
        const { name, value} = event.target;
        this.setState({[name]: value, target_date_support: value});

        if (event.target.value.length === 2 && this.state.target_date_support.length === 1) {
            let newValue = value + "/";
            this.setState({[name]: newValue});
        } else if (event.target.value.length === 5 && this.state.target_date_support.length === 4) {
            let newValue = value + "/";
            this.setState({[name]: newValue});
        };  
    }


    handleDollarInput(event) {
        /* Need to add validation here */
        const { name, value} = event.target;

        // get number without $
        let number = value;
        if(number[0] === '$'){
            number = number.slice(1);
        }

        // check for commas
        // if commas are bad - strip commas, and add new ones
        if(!money.checkForCommas(number)){
            number = money.addCommas( money.removeCommas(number) )
        }

        let $value = '$' + number;
        this.setState({[name]: $value});
    }

    // component loading 
    componentDidMount() {
        //this.props.removeNavBar();
        // amplitude
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('source')){
            amplitude.getInstance().logEvent('new recipient: start new recipient', {'last page': 'received gift'})
        } else {
            amplitude.getInstance().logEvent('new recipient: start new recipient', {'last page': 'plans / home'})
        }
        
    }

    componentWillUnmount() {
        //this.props.restoreNavBar();
    }
    
    render () {
        const urlParams = new URLSearchParams(window.location.search)
        return (
        <div>
            <Header_for_multistep 
                text='Add Recipient'
                handleBackButton={() => this.handleBackButton()}
            />

            <main>
                {this.state.currentStep === 3 ? null :
                <Tracker 
                    currentStep={this.state.currentStep} numOfSteps={2}
                    tags={['Personal Details', 'Goals']}/>
                }
                <Add_step_1 currentStep={this.state.currentStep} 
                                handleChange={this.handleChange}
                                handleDateChange={this.handleDateChange}
                                account_name={this.state.account_name}
                                birthday={this.state.birthday}
                                checkUnique={this.checkUnique}
                                />

                <Add_step_2 currentStep={this.state.currentStep} 
                                handleChange={this.handleChange}
                                handleTargetDateChange={this.handleTargetDateChange}
                                account_name={this.state.account_name}
                                target_savings={this.state.target_savings}
                                target_date={this.state.target_date}
                                handleDollarInput={this.handleDollarInput}
                                birthday={this.state.birthday}
                                />

                <Add_step_3 currentStep={this.state.currentStep} 
                                handleChange={this.handleChange}
                                account_name={this.state.account_name}
                                new_account_id={this.state.new_account_id}
                                updateActiveRecipient={this.props.updateActiveRecipient}
                                source={urlParams.get('source') ? urlParams.get('source') : null}
                                />


            
            { this.state.currentStep === 3 ?
            <Link className='secondary_dark align_center' 
                to={ urlParams.get('source') ? 'receive/'+urlParams.get('source') : 'plan'}
                onClick={() => amplitude.getInstance().logEvent('new recipient: finish')}>
                <p>Finish</p>
            </Link>

            :

            <MasterButton 
                notSticky={true}
                buttonText={this.state.buttonText} 
                handleButtonClick={this.handleButtonClick}
                links={this.state.buttonLinks}
            />
            }

            </main>
        
            <div className='buffer'></div>
            <div className='buffer'></div>

        </div>
        );
    }
}

export default Main_add_account;